import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { AppTester, AppTesterType } from 'supporting';

const IMAGES = {
  hsedesign: 'hsedesign.ru.jpg',
  kiiids: 'kiiids.art.jpg',
  hseSpace: 'hse.space.jpg',
  greenAward: 'green-award.ru.jpg',
  brnd: 'brnd.ru.jpg',
  deziiign: 'deziiign.com.jpg',
  portfolio365: 'portfolio365.ru.jpg',
  booksDeziiign: 'books.deziiign.ru.jpg',
  urbanDeziiign: 'books.deziiign.ru-1.jpg',
  cgrave: 'cgrave.ru.jpg',
  ageytomesh: 'ageytomesh.com.jpg',
  galllleryArt: 'gallllery.art.jpg',
  lmsHsedesign: 'lms.hsedesign.ru.jpg',
  gallllery: 'gallllery.com.jpg',
  // dafes: 'dafes.net.jpg',
  dafes1: 'dafes.net-1.jpg',
  fashionDeziiign: 'fashion.deziiign.ru.jpg',
  proDeziiign: 'pro.deziiign.ru.jpg',
  gameDeziiign: 'game.deziiign.ru.jpg',
  continuum: 'continuum.site.jpg',
  mediiia: 'mediiia.com.jpg',
  dva: 'dva.design.jpg',
  creativeHse: 'creativehse.jpg',
  monalisatravels: 'monalisatravels.com.jpg',
  // ftbl: 'ftbl.com.jpg'
} as const;

export const getMetaImage = (AppTester: AppTesterType) => {
  
  if (AppTester.isCreativeHSE()) {
    return IMAGES.creativeHse;
  }
  if (AppTester.isLMSHSE()) {
    return IMAGES.lmsHsedesign;
  }
  if (AppTester.isHseSpace()) {
    return IMAGES.hseSpace;
  }
  if (AppTester.isHSEDesign()) {
    return IMAGES.hsedesign;
  }
  if (AppTester.isGalllleryArt()) {
    return IMAGES.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return IMAGES.gallllery;
  }
  if (AppTester.isCGRAVE()) {
    return IMAGES.cgrave;
  }
  if (AppTester.isGameDeziiign()) {
    return IMAGES.gameDeziiign;
  }
  if (AppTester.isFashionDeziiign()) {
    return IMAGES.fashionDeziiign;
  }
  if (AppTester.isContext('pro')) {
    return IMAGES.proDeziiign;
  }
  if (AppTester.isBooksDeziiign()) {
    return IMAGES.booksDeziiign;
  }
  if (AppTester.isPortfolio365()) {
    return IMAGES.portfolio365;
  }
  if (AppTester.isKiiidsArt()) {
    return IMAGES.kiiids;
  }
  if (AppTester.isBrnd()) {
    return IMAGES.brnd;
  }
  if (AppTester.isDvaDesign()) {
    return IMAGES.dva;
  }
  if (AppTester.isGreenAward()) {
    return IMAGES.greenAward;
  }
  if (AppTester.isMediiia()) {
    return IMAGES.mediiia;
  }
  if (AppTester.isAgeytomesh()) {
    return IMAGES.ageytomesh;
  }
  if (AppTester.isContinuumSite()) {
    return IMAGES.continuum;
  }
  if (AppTester.isGeoDafes()) {
    return IMAGES.dafes1;
  }
  if (AppTester.isMediiiaUrban()) {
    return IMAGES.urbanDeziiign;
  }
  if (AppTester.isMonaLisaTravels()) {
    return IMAGES.monalisatravels;
  }
  if (AppTester.isDeziiign() || AppTester.isCompetition()) {
    return IMAGES.deziiign;
  }
  return null;
}

const useMetaImage = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');

  const imagePath = useMemo(() => {
  
    return getMetaImage(AppTester);
  }, []);

  if (!imagePath) {
    return null;
  }

  const imageUrl = `${window.location.origin}${process.env.PUBLIC_URL}/meta/${imagePath}`;

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage && !isCompetitionPage;

  return shouldDisplayMeta && [
    <meta key="vk" property="vk:image" content={imageUrl} />,
    <meta key="og" property="og:image" content={imageUrl} />,
    <meta key="twitter" name="twitter:image" content={imageUrl} />,
    <meta name="twitter:card" content="summary_large_image" />
  ];
};

export default useMetaImage;import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { AppTester, AppTesterType } from 'supporting';

const IMAGES = {
  hsedesign: 'hsedesign.ru.jpg',
  kiiids: 'kiiids.art.jpg',
  hseSpace: 'hse.space.jpg',
  greenAward: 'green-award.ru.jpg',
  brnd: 'brnd.ru.jpg',
  deziiign: 'deziiign.com.jpg',
  portfolio365: 'portfolio365.ru.jpg',
  booksDeziiign: 'books.deziiign.ru.jpg',
  urbanDeziiign: 'books.deziiign.ru-1.jpg',
  cgrave: 'cgrave.ru.jpg',
  ageytomesh: 'ageytomesh.com.jpg',
  galllleryArt: 'gallllery.art.jpg',
  lmsHsedesign: 'lms.hsedesign.ru.jpg',
  gallllery: 'gallllery.com.jpg',
  // dafes: 'dafes.net.jpg',
  dafes1: 'dafes.net-1.jpg',
  fashionDeziiign: 'fashion.deziiign.ru.jpg',
  proDeziiign: 'pro.deziiign.ru.jpg',
  gameDeziiign: 'game.deziiign.ru.jpg',
  continuum: 'continuum.site.jpg',
  mediiia: 'mediiia.com.jpg',
  dva: 'dva.design.jpg',
  creativeHse: 'creativehse.jpg',
  monalisatravels: 'monalisatravels.com.jpg',
  // ftbl: 'ftbl.com.jpg'
} as const;

export const getMetaImage = (AppTester: AppTesterType) => {
  
  if (AppTester.isCreativeHSE()) {
    return IMAGES.creativeHse;
  }
  if (AppTester.isLMSHSE()) {
    return IMAGES.lmsHsedesign;
  }
  if (AppTester.isHseSpace()) {
    return IMAGES.hseSpace;
  }
  if (AppTester.isHSEDesign()) {
    return IMAGES.hsedesign;
  }
  if (AppTester.isGalllleryArt()) {
    return IMAGES.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return IMAGES.gallllery;
  }
  if (AppTester.isCGRAVE()) {
    return IMAGES.cgrave;
  }
  if (AppTester.isGameDeziiign()) {
    return IMAGES.gameDeziiign;
  }
  if (AppTester.isFashionDeziiign()) {
    return IMAGES.fashionDeziiign;
  }
  if (AppTester.isContext('pro')) {
    return IMAGES.proDeziiign;
  }
  if (AppTester.isBooksDeziiign()) {
    return IMAGES.booksDeziiign;
  }
  if (AppTester.isPortfolio365()) {
    return IMAGES.portfolio365;
  }
  if (AppTester.isKiiidsArt()) {
    return IMAGES.kiiids;
  }
  if (AppTester.isBrnd()) {
    return IMAGES.brnd;
  }
  if (AppTester.isDvaDesign()) {
    return IMAGES.dva;
  }
  if (AppTester.isGreenAward()) {
    return IMAGES.greenAward;
  }
  if (AppTester.isMediiia()) {
    return IMAGES.mediiia;
  }
  if (AppTester.isAgeytomesh()) {
    return IMAGES.ageytomesh;
  }
  if (AppTester.isContinuumSite()) {
    return IMAGES.continuum;
  }
  if (AppTester.isGeoDafes()) {
    return IMAGES.dafes1;
  }
  if (AppTester.isMediiiaUrban()) {
    return IMAGES.urbanDeziiign;
  }
  if (AppTester.isMonaLisaTravels()) {
    return IMAGES.monalisatravels;
  }
  if (AppTester.isDeziiign() || AppTester.isCompetition()) {
    return IMAGES.deziiign;
  }
  return null;
}

const useMetaImage = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');

  const imagePath = useMemo(() => {
  
    return getMetaImage(AppTester);
  }, []);

  if (!imagePath) {
    return null;
  }

  const imageUrl = `${window.location.origin}${process.env.PUBLIC_URL}/meta/${imagePath}`;

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage && !isCompetitionPage;

  return shouldDisplayMeta && [
    <meta key="vk" property="vk:image" content={imageUrl} />,
    <meta key="og" property="og:image" content={imageUrl} />,
    <meta key="twitter" name="twitter:image" content={imageUrl} />,
    <meta name="twitter:card" content="summary_large_image" />
  ];
};

export default useMetaImage;